
import { CREATE_ACCESS_GROUP } from '@/views/Project/access/gql/mutations.ts'
import { accessClient } from '@/apolloClient'
import DialogTemplate from '@/_components/dialog/template/template.vue'

export default {
    name: 'AccessControlGroupDialog',
    components: { DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            newGroupName: '',
            isAddingNewGroup: false,
        }
    },
    methods: {
        closeDialog() {
            this.$emit('close')
        },
        async addNewAccessGroup() {
            if (!this.newGroupName || this.isAddingNewGroup) {
                return
            }

            try {
                this.isAddingNewGroup = true
                const result = await accessClient.mutate({
                    mutation: CREATE_ACCESS_GROUP,
                    variables: {
                        projectId: this.currentProjectId,
                        name: this.newGroupName,
                    },
                })
                this.$emit('close', { addedGroup: result.data.createAccessGroup.group })
            } finally {
                this.isAddingNewGroup = false
            }
        },
    },
}
